import { type FC } from 'react';

export type ImagePropsAlignment = `${'top' | 'center' | 'bottom'} ${'left' | 'center' | 'right'}`;

interface ImgSrcSet {
    src: string;
    media: string;
}

export interface ImageProps {
    caption?: string;
    imgCustomClass?: string;
    aspectRatio?: string;
    alignment?: ImagePropsAlignment;
    imgWidth?: number | `${number}%` | 'auto';
    imgHeight?: number | `${number}%` | 'auto';
    imgSrcSet?: ImgSrcSet[];
    imgSrc: string;
    imgAlt?: string;
    disableLazyLoading?: boolean;
    objectFit?: string;
    ariaLabel?: string;
}


const Image: FC<ImageProps> = ({ caption, imgCustomClass = '', aspectRatio, alignment = 'center center', imgWidth, imgHeight, imgSrcSet, imgSrc, imgAlt, disableLazyLoading, objectFit, ariaLabel }: ImageProps) => {
    const imgClass = `image-wrapper ${imgCustomClass}`;
    const aspectRatioStyle = aspectRatio ? { '--aspect-ratio': aspectRatio } : {};
    const alignmentStyle = { '--image-alignment': alignment };

    const style = {
        '--image-width': imgWidth,
        '--image-height': imgHeight,
        '--image-object-fit': objectFit || 'cover',
        ...alignmentStyle,
        ...aspectRatioStyle,
    } as unknown as React.CSSProperties;

    const loading = disableLazyLoading ? 'eager' : 'lazy';

    return (
        <div
            className={imgClass}
            style={style}
        >
            <figure>
                <picture className={`${aspectRatio ? 'has-ratio' : ''}`}>
                    {imgSrcSet?.map(({ src, media }) => {
                        return (
                            <source key={src} srcSet={src} media={media} />
                        );
                    })}
                    <img
                        src={imgSrc}
                        alt={imgAlt}
                        width={imgWidth}
                        height={imgHeight}
                        loading={loading}
                        decoding="async"
                        aria-label={ariaLabel}
                    />
                </picture>
                {caption && (
                    <figcaption>{caption}</figcaption>
                )}
            </figure>
        </div>
    );
};

export default Image;
